import React, {Component} from "react";
import {Link} from "react-router";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";
import CodeBlock from "../../../common/CodeBlock";
import {currentSiteName} from "../../../service/SiteService";

class ActionSecurity extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Action Security</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>
                                    Lock and unlock jobs. Control who has access to performs
                                    certain <Link to="/docs/bot/actions">actions</Link> and on which jobs.
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h3>Lock and unlock jobs</h3>

                                <p>You might want to lock an option value, so that it cannot be passed to an action.</p>

                                <blockquote>
                                    <p>Example: If you have an option to specify the environment for a deployment, you might wish to lock deployments to the
                                        environment named 'production'.</p>
                                </blockquote>

                                <p>You can accomplish this using the <code>lockable</code> property of an option within the <code>options</code> action block:
                                </p>

                                <CodeBlock code={`version: '1'
actions:
  services:
    jobId: 9374f1c8-7b3f-4145-8556-6b55551fb60f
    template: deploy services {version} to {environment}
    options:
      environment:
        lockable: true
`}/>

                                <p>If the user typed this command:</p>

                                <pre><code>@cloudMocks lock environment prod</code></pre>

                                <p>This will result in a lock being placed on the 'environment' option, with the value 'prod'.</p>

                                <p>With the lock applied, this will fail:</p>

                                <pre><code>@cloudMocks deploy services 1.0 to prod</code></pre>

                                <p>...but this will still succeed:</p>

                                <pre><code>@cloudMocks deploy services 1.0 to uat</code></pre>

                                <p>You can of course unlock the option with:</p>

                                <pre><code>@cloudMocks unlock environment prod</code></pre>

                                <blockquote>
                                    <p>Note: It's strongly advisable to apply a <em>transformer</em> to lockable options, to ensure the value 'prod' is
                                        considered equivalent to 'PROD'. To learn more about transformers, see
                                        the <Link to="/docs/bot/actions">Actions</Link> documentation.</p>
                                </blockquote>

                                <h3>Roles and Permissions</h3>

                                <p>
                                    {currentSiteName} has a powerful Role-based access control (RBAC) security
                                    model that allows you to control which users can perform certain <Link to="/docs/bot/actions">actions</Link>, and on which jobs.
                                </p>
                                <p>You can choose which users are authorised to perform actions, using the <code>security</code> block:</p>

                                <CodeBlock code={`security:
  users:
    # alice uses the built-in 'admin' role
    alice:
      roles:
        - admin
`}/>

                                <blockquote>
                                    <p><em>Important:</em> if you do not specify a security configuration explicitly, the default will be used. The default
                                        settings permit all users to perform all actions.</p>
                                </blockquote>

                                <p>There is a built in role, named <code>admin</code>, which you can assign to users. You can also define your own roles,
                                    listing the permissions granted to users with that role.</p>

                                <p>You can assign roles on a per-username basis or, if you wish to assign certain roles to all users, use the special
                                    <code>"*"</code> key, as shown in the example below:</p>

                                <CodeBlock code={`security:
  roles:
    # a role that can only trigger jobs
    deployer:
      permissions:
        - trigger

  users:
    # alice uses the built-in 'admin' role
    alice:
      roles:
        - admin

    # all users can trigger jobs
    "*":
      roles:
        - deployer
`}/>

                                <h4>Security using tags</h4>

                                <p>By default, role definitions apply to all actions. If you wish to restrict the permissions granted by a role to certain
                                    actions only, add a tag to the action and also to the corresponding <code>tags</code> array in the role.</p>

                                <blockquote>To learn more about tags see the <Link to="/docs/bot/actions">Actions</Link> documentation.</blockquote>

                                <p>Here's an example using tags and security:</p>

                                <CodeBlock code={`security:
  roles:
    # a role that can only trigger jobs
    deployer:
      permissions:
        - trigger

    # this role only permits triggering of actions tagged with 'services'
      tags:
        - services
`}/>

                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default ActionSecurity;



// WEBPACK FOOTER //
// ./src/modules/views/docs/bot/ActionSecurity.js